unit UnitMain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.WebCtrls, System.DateUtils, WEBLib.ExtCtrls, XData.Web.Connection,
  XData.Web.Client, jsdelphisystem, WEBLib.Storage,  Bcl.Utils,   CP.Func.AES,  WEBLib.REST, WEBLib.JSON, Vcl.Menus,
  WEBLib.Menus, VCL.TMSFNCButton, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer, VCL.TMSFNCStateManager, VCL.TMSFNCResponsiveManager, WebBasis, WebBasis2;

type
  TfrmMainForm = class(TfrmWebBasis)
    XDataConn: TXDataWebConnection;
    tmrJWTRenewal: TTimer;
    tmrJWTRenewalWarning: TTimer;
    WebHttpRequest1: THttpRequest;
    tmrCapture: TTimer;
    pnlMenu: TPanel;
    mMainmenu: TMainMenu;
    mnDispo: TMenuItem;
    mnResponsiv: TMenuItem;
    mnSystem: TMenuItem;
    mnAbmelden: TMenuItem;
    Passwortndern1: TMenuItem;
    pnlStatus: TPanel;
    XDataWebClient: TXDataWebClient;
    WebSplitter1: TSplitter;
    tabAnwAbw: TXDataWebDataSet;
    tabAnwAbwANWABW_NR: TIntegerField;
    tabAnwAbwANWABW_BEZ: TStringField;
    tabAnwAbwANWABW_TYP: TIntegerField;
    tabAnwAbwANWABW_KURZ: TStringField;
    tabAnwAbwANWABW_FARBE: TStringField;
    MainScrollBox: TScrollBox;
    mnTransportauftraege: TMenuItem;
    lbWebTitel: TLabel;
    lbBenutzer: TLabel;
    WebPanel1: TPanel;
    ouren1: TMenuItem;
    mnFormSchliessen: TMenuItem;
    mnAktivesFahrzeug: TMenuItem;
    mnFahrzeuge: TMenuItem;
    mnSchaeden: TMenuItem;
    mnMitarbeiter: TMenuItem;
    mnMaterialBestellungen: TMenuItem;
    mnUrlaub: TMenuItem;
    MitarbeiterBelege1: TMenuItem;
    mnAbfKontrolle: TMenuItem;
    mnZeitbuchungen: TMenuItem;
    Position1: TMenuItem;
    mnInfo: TMenuItem;
    mnFsKontrollen: TMenuItem;

    procedure XDataConnRequest(Args: TXDataWebConnectionRequest);
    procedure Toast(Header: String; Body: String; Timeout: Integer);
    procedure ProcessJWT(aJWT: String);
    procedure WebFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrJWTRenewalWarningTimer(Sender: TObject);
    procedure WebFormClick(Sender: TObject);
    procedure FinalRequest;

    [async] procedure LogAction(Action: String; Extend: Boolean); async;
    [async] procedure WebFormCreate(Sender: TObject); async;
    [async] procedure Logout(Reason: String); async;
    [async] procedure LoadForm(Form: String); async;
    [async] procedure LoadSubForm(SubForm: String; NewInstance: Boolean); async;
    [async] procedure XDataConnect( bTest : Boolean=False); async;
    [async] procedure tmrJWTRenewalTimer(Sender: TObject); async;
    [async] function XDataLogin( aUsername: String; aPassword: String):String; async;
    [async] function JSONRequest(Endpoint: String; Params: Array of JSValue):String; async;

    [async] procedure SprachDaten_Laden( aID_Sprache : Integer =0 ); async;
    [async] procedure Form_Uebersetzen; async;

    [async] procedure ErzeugeTau; async;
    [async] procedure Position1Click(Sender: TObject); async;
    [async] procedure mnAktivesFahrzeugClick(Sender: TObject); async;

    procedure WebFormHashChange(Sender: TObject; oldURL, newURL: string);
    function CaptureState:JSValue;
    procedure UpdateNav;
    procedure NavHistoryBack;
    procedure NavHistoryForward;
    procedure tmrCaptureTimer(Sender: TObject);
    procedure RecordSession;
    [async] procedure PlaybackSession; async;
    procedure btnViewerCloseClick(Sender: TObject);
    procedure divViewerImageClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure XDataConnConnect(Sender: TObject);
    procedure mnMitarbeiterClick(Sender: TObject);
    procedure mnBuchungenClick(Sender: TObject);
    procedure mnAbmeldenClick(Sender: TObject);
    procedure Loganzeigen1Click(Sender: TObject);
    procedure Abwesenheiten1Click(Sender: TObject);
    procedure mnAbwesenheitsVerwaltungClick(Sender: TObject);
    procedure mnAbschlussClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure mnResponsivClick(Sender: TObject);
    procedure mnTransportauftraegeClick(Sender: TObject);
    procedure ouren1Click(Sender: TObject);
    procedure mnFormSchliessenClick(Sender: TObject);
    procedure FormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure mnSchaedenClick(Sender: TObject);
    procedure mnMaterialBestellungenClick(Sender: TObject);
    procedure mnUrlaubClick(Sender: TObject);
    procedure MitarbeiterBelege1Click(Sender: TObject);
    procedure mnAbfKontrolleClick(Sender: TObject);
    procedure mnZeitbuchungenClick(Sender: TObject);
    [async] procedure mnInfoClick(Sender: TObject); async;
    procedure mnFsKontrollenClick(Sender: TObject);


  private
    procedure Opt_Laden;
    procedure Opt_Speichern;
    procedure Set_BenutzerInfo;
  public
    App_Name: String;
    App_Short: String;
    App_Version: String;
    App_Release: String;
    App_Start: TDateTime;
    App_Start_UTC: TDateTime;
    App_Session: String;

    App_TZ: String;
    App_TZOffset: Integer;
    App_LogDateTimeFormat: String;
    App_DisplayDateTimeFormat: String;
    App_LogDateFormat: String;
    App_DisplayDateFormat: String;
    App_LogTimeFormat: String;
    App_DisplayTimeFormat: String;


    g_XDataServer_URL: String;
    g_RecAnzahl : Integer;
    g_WaitGifURL : String;

    IstHttps : Boolean;
    IstLocalHost : Boolean;

    LoggedIn: Boolean;
    ActivityDetected: Boolean;
    IconSet: String;

    ActionLog: TStringList;
    ActionLogCurrent: TStringList;
    LogVisible: Boolean;

    CurrentForm: TForm;
    CurrentFormName: String;
    CurrentFormNiceName: String;
    CurrentFormShortName: String;
    CurrentFormIcon: String;

    CurrentSubForm: TForm;
    CurrentSubFormName: String;
    CurrentSubFormNiceName: String;
    CurrentSubFormShortName: String;
    CurrentSubFormIcon: String;

    JWT: String;
    JWT_Expiry: TDateTime;
    Remember: Boolean;

    MandantName : String;
    BenutzerLftID   : String;
    BenutzerLftName : String;
    BenutzerMaVorname: String;
    BenutzerMaZuname: String;
    BenutzerMaNr: String;
    User_EMail: String;
    User_Photo: String;
    User_Account: String;

    iID_AktFzg : Integer;
    sAktFahrzeug : String;

    // Back/Forward History
    StartPosition: Integer;
    Position: Integer;
    URL: String;

    // Screen Recording
    RecordingSession: Boolean;
    CaptureData: JSValue;

    //[async] function AnwAbw_Laden : String;
    //[async] procedure FillCBX_Mit_AnwAbw( aCbx : TWebComboBox; aDataSet : TXDataWebDataSet; bNurStempel : Boolean );

    procedure Set_BenutzerAktiv( bAktiv : Boolean );
    procedure StopLinkerRemoval(P: Pointer);
    procedure PreventCompilerHint(I: integer); overload;
    procedure PreventCompilerHint(S: string); overload;
    procedure PreventCompilerHint(J: JSValue); overload;
    procedure PreventCompilerHint(H: TJSHTMLElement); overload;
  protected procedure LoadDFMValues; override; end;

var frmMainForm: TfrmMainForm;

const ch = chr(39);

implementation

{$R *.dfm}

uses UnitLogin, SpediFucsDatenmodul, GlobalWeb, Tau, Tour, GetStammdaten, Schaeden, MaBst, UrlbAntrag, MaBeleg,
     AbfKontrolle, Zeitbuchung, ShowPos, GetBarcode, FsKontrolle;

//====================================================================================================================//

procedure TfrmMainForm.WebFormCreate(Sender: TObject);
var
  i : Int64;
  n : Integer;
  ConfigResponse: TJSXMLHttpRequest;
  ConfigData: TJSONObject;
  ConfigURL, sTmp  : String;
  aSL : TStringList;
  aBytes : TBytes;
const c_Code = '1234567890123456';
begin

  console.log('frmMainForm.WebFormCreate - Start');

  // Application Information
  App_Name := 'SpediFucs';
  App_Short := 'SpediFucs';
  App_Version := '1.2';
  App_Release := '2025-Apr-11';
  App_Start := Now();
  App_Start_UTC := TTimeZone.Local.ToUniversalTime(Now);

  // MainForm Options
  frmMainForm.Caption := App_Name;
//  MainForm.divHost.ElementHandle.style.setProperty('opacity','0');


  // Overide some locale options?
  FormatSettings.ShortDateFormat := 'dd.mm.yyyy' ;
  FormatSettings.LongDateFormat  := 'dd.mm.yyyy HH:nn' ;
  FormatSettings.DateSeparator   := '.';
  FormatSettings.TimeSeparator	 := ':';


  asm
    this.App_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.App_TZOffset = new Date().getTimezoneOffset();
  end;

  // These are intended for use with Delphi's FormatDateTime
  App_LogDateTimeFormat     :=  'dd.MM.yyyy HH:nn:zzz'; // 'yyyy-MM-dd HH:nn:ss.zzz';
  App_DisplayDateTimeFormat :=  'dd.MM.yyyy HH:nn'; // 'yyyy-MMM-dd HH:nn';
  App_LogDateFormat         :=  'dd.MM.yyyy';  //'yyyy-MM-dd';
  App_DisplayDateFormat     :=  'dd.MM.yyyy';  // 'yyyy-MMM-dd';
  App_LogTimeFormat         :=  'HH:nn:ss.zzz';
  App_DisplayTimeFormat     :=  'HH:nn:ss';


  // These are intended for use with Luxon's toFormat
  asm
    window.LogDateTimeFormat = this.App_LogDateTimeFormat.replace('nn','mm');
    window.DisplayDateTimeFormat = this.App_DisplayDateTimeFormat.replace('nn','mm');
    window.LogDateFormat = this.App_LogDateFormat.replace('nn','mm');
    window.DisplayDateFormat = this.App_DisplayDateFormat.replace('nn','mm');
    window.LogTimeFormat = this.App_LogTimeFormat.replace('nn','mm');
    window.DisplayTimeFormat = this.App_DisplayTimeFormat.replace('nn','mm');
  end;


  // Application State
  LoggedIn := true;
  LogVisible := true;
  RecordingSession := False;

  // JWT Handling
  JWT := '';
  JWT_Expiry := App_Start_UTC;
  Remember := True;

  // User Information
  BenutzerMaVorname := '';
  BenutzerMaZuname  := '';
  BenutzerMaNr :=  '';
  User_EMail   := '';
  User_Account := '';

  // Role Information
//  User_Roles := TStringList.Create;
//  Role_Administrator := False;
//  Roles := '';

  // Log what we're doing in the application
  ActionLog := TStringList.Create;
  ActionLog.Delimiter := chr(10);
  ActionLogCurrent := TStringList.Create;
  ActionLogCurrent.Delimiter := chr(10);
  CurrentFormName := 'Module / Dashboard - Page';
  LogAction('============================================================', False);

  // Form Management
  CurrentForm := nil;
  CurrentFormName := 'Initializing';
  CurrentFormIcon := '';
  CurrentSubForm := nil;
  CurrentSubFormName := '';
  CurrentSubFormIcon := '';

  // Forms and SubForms that we've defined so far in this project
  asm {
    window.ValidForms = [
      'AdministratorForm',
      'LoginForm'
    ];
    window.ValidSubForms = [
      'AdministratorSub',
      'ChatStatisticsSub',
      'UserActionsSub',
      'UserProfileSub'
    ]
  } end;

  // Create an App Session key - just a custom Base48-encoded timestamp
  // https://github.com/marko-36/base29-shortener
  App_Session := '';
  i := DateTimeToUnix(App_Start_UTC);

  asm
    // Encode Integer (eg: Unix Timestamp) into String
    const c = ['B','b','C','c','D','d','F','f','G','g','H','h','J','j','K','k','L','M','m','N','n','P','p','Q','q','R','r','S','s','T','t','V','W','w','X','x','Z','z','0','1','2','3','4','5','6','7','8','9'];
    var sLen = Math.floor(Math.log(i)/Math.log(c.length)) +1;
    for(var ex=sLen-1; ex>-1; --ex){
      this.App_Session += c[Math.floor(i / Math.pow(c.length,ex))];
      i = [i % Math.pow(c.length,ex)];
    }

    // Decode String into Integer
    // var s = this.App_Session;
    // i = 0;
    // for (var ex=0; ex<s.length; ++ex){
    //   i += c.indexOf(s.substring(ex,ex+1)) * Math.pow(c.length,s.length-1-ex);
    // }
    // return i
  end;



  // Application Details
  LogAction('Application Startup', False);
  LogAction(' -> '+App_Name, False);
  LogAction(' -> Version '+App_Version, False);
  LogAction(' -> Release '+App_Release, False);
  LogAction(' -> App Started: '+FormatDateTime(App_LogDateTimeFormat, App_Start)+' '+App_TZ, False);
  LogAction(' -> App Started: '+FormatDateTime(App_LogDateTimeFormat, App_Start_UTC)+' UTC', False);
  LogAction(' -> App Session: '+App_Session, False);
  LogAction('============================================================', False);
  LogAction(' ', False);


  // Setup global sleep function :)
  asm window.sleep = async function(msecs) {return new Promise((resolve) => setTimeout(resolve, msecs)); } end;

  // console.image function
  asm
    function getBox(width, height) {
      return {
        string: "+",
        style: "font-size: 1px; padding: " + Math.floor(height/4) + "px " + Math.floor(width/2) + "px; line-height: " + height/2 + "px;"
    }}

    console.image = function(url, scale) {
      scale = scale || 1;
      var img = new Image();
      img.onload = function() {
        var dim = getBox(this.width * scale, this.height * scale);
        console.log("%c" + dim.string, dim.style + "background: url(" + url + "); background-size: " + (this.width * scale) + "px " + (this.height * scale) + "px; color: transparent;");
      };
      img.src = url;
    }
  end;


  g_XDataServer_URL := '';
  g_RecAnzahl  := 50;
  g_WaitGifURL := '';


  Try
    asm sTmp = window.location.origin+(window.location.pathname.split('/').slice(0,-1).join('/')+'/WaitMessage.gif').replace('/\/\//g','/'); end;
  except
    console.log('Fehler: '+ sTmp );
  End;

  frmMainForm.g_WaitGifURL := sTmp;
  //console.log('g_WaitGifURL: '+ frmMainForm.g_WaitGifURL );

  try
    asm ConfigURL = window.location.origin+(window.location.pathname.split('/').slice(0,-1).join('/')+'/spedifucs.cnf').replace('/\/\//g','/'); end;

    console.log('Lade Konfiguration aus: '+ConfigURL);

    WebHTTPRequest1.URL := ConfigURL;
    ConfigResponse := await( TJSXMLHttpRequest, WebHTTPRequest1.Perform() );



    If String(COnfigResponse.Response) <> '' then
    Begin



      sTmp := String(COnfigResponse.Response);
      sTmp := await( Crypt( sTmp ) );

      Console.log('>> '+sTmp);

      aSL := TStringList.Create;
      aSL.Text :=  sTmp ;
      g_XDataServer_URL := aSL.Values['XDATA_SRV'] ;


      console.log('frmMainForm.WebFormCreate - XDATA: '+g_XDataServer_URL);

      sTmp := aSL.Values['REC_ANZ'] ;
      If sTmp <>'' then
      Try
        g_RecAnzahl := StrToIntDef(sTmp, 50);
      Except
        LogAction('REC_ANZ - FEHLER: NICHT NUMMERISCH',False);
      End;

      LogAction('Einstellungen sind geladen - XDATA_SRV: '+aSL.Values['XDATA_SRV'], False );
      LogAction('Einstellungen sind geladen - REC_ANZ: '+sTmp, False );
      aSL.Free;

      If (g_XDataServer_URL = '') then
        Begin
          g_XDataServer_URL := 'http://localhost:2001/tms/xdata';
          LogAction('Server (Config Missing-Using Default): '+g_XDataServer_URL, False);
          console.log('Server (Config Missing-Using Default): '+g_XDataServer_URL);
        End;

      // Connect to XData - it will finish on its own time but give it a moment to connect
      XDataConnect;

    End;
  except on E:Exception do
    begin
    end
  end;


  // Launch Login
  CurrentFormName := 'LoginForm';
  LoadForm('LoginForm');

  console.log('WebFormCreate - Ende');


  // Set our current state as the state we want to go back to
  Position := window.history.length;
  StartPosition := window.history.length;
  URL := window.location.href;
  window.history.pushState(CaptureState, '', URL);
  Position := window.history.length;
  window.history.pushState(CaptureState, '', URL);

  // What to do when we hit back/forward button
//  asm
//    window.addEventListener('popstate', function(popstateEvent)  {
//      pas.UnitMain.MainForm.RevertState(popstateEvent.state);
//    });
//  end;


  PreventCompilerHint(i);


end;

//====================================================================================================================//

procedure TfrmMainForm.WebFormHashChange(Sender: TObject; oldURL, newURL: string);
//var
//  NewForm: String;
//  NewSubForm: String;
begin
//  asm
//    if (newURL.split('#').length == 2) {
//      if (newURL.split('#')[1].split('/').length == 2) {
//        NewForm = newURL.split('#')[1].split('/')[0];
//        NewSubForm = newURL.split('#')[1].split('/')[1];
//      }
//    }
//  end;
//
//  if (NewForm <> CurrentFormName) and (NewForm <> '')
//  then LoadForm(NewForm);
//
//  if (NewSubForm <> CurrentSubFormName) and (NewSubForm <> '')
//  then LoadSubForm(NewSubForm, False);

end;


//====================================================================================================================//

procedure TfrmMainForm.Opt_Laden;
var sTmp: String;
begin

  sTmp := TLocalStorage.GetValue('AKT_FZG_ID' );
  If sTmp='' then sTmp := '0';
  iID_AktFzg   := StrToIntDef(sTmp,0);

  sTmp := TLocalStorage.GetValue('AKT_FZG_KENNZEICHEN' );
  sAktFahrzeug := sTmp;

  console.log('AKT_FZG_KENNZEICHEN:  '+ sAktFahrzeug);

end;

//====================================================================================================================//

procedure TfrmMainForm.Opt_Speichern;
var sAbf : String;
begin

  TLocalStorage.SetValue( 'AKT_FZG_ID', IntToStr(iID_AktFzg) );
  TLocalStorage.SetValue( 'AKT_FZG_KENNZEICHEN', sAktFahrzeug   );

end;


//====================================================================================================================//

procedure TfrmMainForm.Set_BenutzerAktiv( bAktiv : Boolean );
var sTmp : String;
begin

  mMainMenu.BeginUpdate;

    mnDispo.Visible  := bAktiv;
    mnDispo.Enabled  := bAktiv;
    mnSystem.Visible := bAktiv;
    mnSystem.Enabled := bAktiv;
    mnFahrzeuge.Visible := bAktiv;
    mnFahrzeuge.Enabled := bAktiv;
    mnMitarbeiter.Visible := bAktiv;
    mnMitarbeiter.Enabled := bAktiv;

    mnAbmelden.Enabled    := bAktiv;
    MainScrollBox.Visible := bAktiv;

  mMainMenu.EndUpdate;


  sTmp := UpperCase( Copy(self.URL, 1,5));
  self.IstHttps := (sTmp = 'HTTPS');

  self.IstLocalHost := ( Pos('LOCALHOST',  UpperCase(self.URL) ) > 0 );


end;

//====================================================================================================================//

procedure TfrmMainForm.mnAbfKontrolleClick(Sender: TObject);
begin
  inherited;
  LoadForm('AbfKontrolle');
end;

procedure TfrmMainForm.Abwesenheiten1Click(Sender: TObject);
begin
  Showmessage('Das Formular ist nicht implementiert');
end;

//====================================================================================================================//

procedure TfrmMainForm.WebButton3Click(Sender: TObject);
begin
 LoadForm('Buchungen');
end;

//====================================================================================================================//

procedure TfrmMainForm.Position1Click(Sender: TObject);
var aModelResult : TModalResult;
    iTab, iID_Fzg : Integer;
    sBez, sKennz : String;
    aModalResult : TModalResult;
begin
  inherited;

  iTab := c_Fzg;
  iID_Fzg := iID_AktFzg;
  sBez   := '';

  If iID_Fzg = 0 then
    Begin
      aModalResult := await( TModalResult, Get_Stammdaten2( iTab, iID_Fzg, sBez ) );
      If aModalResult <> mrOK then Exit;
    End;

  Show_FzgPos( iID_Fzg ) ;

end;

//====================================================================================================================//

procedure TfrmMainForm.WebFormClick(Sender: TObject);
begin
  if (CurrentFormName <> 'LoginForm') then ActivityDetected := True;
end;

//====================================================================================================================//

procedure TfrmMainForm.FinalRequest;
begin
  LogAction('Application Unloaded',False);
  LogAction('Session Duration: '+FormatDateTime('h"h "m"m "s"s"', Now - App_Start), False);
  JSONRequest('ISystemService.Renew',[App_Session, ActionLogCurrent.Text]);
end;

//====================================================================================================================//

procedure TfrmMainForm.WebFormKeyDown(Sender: TObject; var Key: Word;    Shift: TShiftState);
begin
  if (Key = VK_F4) then Logout('F4');
end;

//====================================================================================================================//

procedure TfrmMainForm.WebFormResize(Sender: TObject);
begin

  If self.Width < 500 then
    Begin
      lbWebTitel.Alignment := taLeftJustify;
      lbBenutzer.Alignment := taLeftJustify;
    End
  Else
    Begin
      lbWebTitel.Alignment := taCenter;
      lbBenutzer.Alignment := taCenter;
    End;

end;

//====================================================================================================================//

procedure TfrmMainForm.WebFormShow(Sender: TObject);
begin

  dmSpediFucs := TdmSpediFucs.Create(nil);

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmMainForm.ErzeugeTau;
var sMsg : String;

    procedure AfterCreate(AForm: TObject);
    begin
      TfrmWebBasis(CurrentForm).Sprach_Daten_Laden('TAU', self.iID_Sprache );
    end;
begin

  CurrentForm := TfrmTau.CreateNew( MainScrollBox.ElementID, @AfterCreate);

end;

//====================================================================================================================//

procedure TfrmMainForm.LoadForm( Form: String );
var ElapsedTime: TDateTime;
    ValidForm: Boolean;
    sMsg : String;

    procedure AfterCreate(AForm: TObject);
    begin
      //LogAction('Load Form: '+Form+' Loaded ('+IntToStr(MillisecondsBetween(Now, ElapsedTime)-500)+'ms)', False);
      If CurrentFormName = 'Tau' then   TfrmWebBasis(CurrentForm).Sprach_Daten_Laden('TAU', self.iID_Sprache );
      If CurrentFormName = 'Tour' then  TfrmWebBasis(CurrentForm).Sprach_Daten_Laden('TOUR', self.iID_Sprache );
    end;

begin
  // Time this action
  ElapsedTime := Now;

  sMsg := 'Start LoadForm: '+Form;
  If Assigned(CurrentForm) then sMsg := sMsg + ' - CurrentForm: '+CurrentFormName;


  // Remove old Form
  If Assigned(CurrentForm) then
    Begin
      CurrentForm.Close;
      CurrentForm.Free;
    End;

  // Das neue Formular merken
  //
  CurrentFormName := Form;

  If (Form <> 'LoginForm') then  TLocalStorage.SetValue('Login.CurrentForm', Form);

  LogAction('Create Form: '+Form, False);

  // Neues Formular erzeugen
  //
  if (Form = 'LoginForm') then
  begin
    CurrentFormNiceName  := 'Login';
    CurrentFormShortName := 'Login';
    CurrentForm := TLoginForm.CreateNew( @AfterCreate);
  end
  else if (Form = 'MainForm') then
  begin
    CurrentFormNiceName  := 'Main';
    CurrentFormShortName := 'Main';
  end

  else if (Form = 'Schaeden') then
  begin
    CurrentFormNiceName := 'Schaeden';
    CurrentFormShortName := 'Schaeden';
    CurrentForm := TfrmSchaeden.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end

  else if (Form = 'MaterialBestellungen') then
  begin
    CurrentFormNiceName := 'MaterialBestellungen';
    CurrentFormShortName := 'MaterialBestellungen';
    CurrentForm := TfrmMaBst.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end

  else if (Form = 'FsKontrollen') then
  begin
    CurrentFormNiceName := 'Führerscheinkontrollen';
    CurrentFormShortName := 'Führerscheinkontrollen';
    CurrentForm := TfrmFsKontrolle.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end


  else if (Form = 'MitarbeiterBelege') then
  begin
    CurrentFormNiceName := 'MitarbeiterBelege';
    CurrentFormShortName := 'MitarbeiterBelege';
    CurrentForm := TfrmMaBeleg.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end

  else if (Form = 'UrlbAntrag') then
  begin
    CurrentFormNiceName  := 'UrlbAntrag';
    CurrentFormShortName := 'UrlbAntrag';
    CurrentForm := TfrmUrlbAntrag.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end


  else if (Form = 'Zeitbuchungen') then
  begin
    CurrentFormNiceName  := 'Zeitbuchungen';
    CurrentFormShortName := 'Zeitbuchungen';
    CurrentForm := TfrmZeitbuchung.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end

  else if (Form = 'AbfKontrolle') then
  begin
    CurrentFormNiceName  := 'AbfKontrolle';
    CurrentFormShortName := 'AbfKontrolle';
    CurrentForm := TfrmAbfKontrolle.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end


  else if (Form = 'Tau') then
  begin
    CurrentFormNiceName := 'Tau';
    CurrentFormShortName := 'Tau';
    CurrentForm := TfrmTau.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end

    else if (Form = 'Tour') then
  begin
    CurrentFormNiceName := 'Tour';
    CurrentFormShortName := 'Tour';
    CurrentForm := TfrmTour.CreateNew( MainScrollBox.ElementID, @AfterCreate);
  end;


//  else if (Form = 'AbwVerwaltung') then
//  begin
//    CurrentFormNiceName := 'Abwesenheitsverwaltung';
//    CurrentFormShortName := 'Abwesenheitsverwaltung';
//    CurrentForm := TfrmAbwVerwaltung.CreateNew( MainScrollBox.ElementID, @AfterCreate);
//  end;


  sMsg := 'Ende LoadForm: '+Form;
  If Assigned(CurrentForm) then sMsg := sMsg + ' - CurrentForm: '+CurrentFormName;
  //Console.Add(sMsg  );

end;

//====================================================================================================================//

procedure TfrmMainForm.LoadSubForm(SubForm: String; NewInstance: Boolean);
var
  ElapsedTime: TDateTime;
  ValidSubForm: Boolean;
  divSubForm: TJSElement;

  procedure AfterSubCreate(AForm: TObject);
  begin
    LogAction('Load SubForm: '+SubForm+' Loaded ('+IntToStr(MillisecondsBetween(Now, ElapsedTime)-500)+'ms)', False);

    document.getElementById('labelDashboard').innerHTML := CurrentSubFormIcon+CurrentSubFormNiceName;
    document.getElementById('bcDashboard').innerHTML := CurrentFormIcon+CurrentFormNiceName;
    document.getElementById('bcCurrent').innerHTML := CurrentSubFormIcon+CurrentSubFormNiceName;

    URL := '#'+CurrentFormName+'/'+CurrentSubFormName;
    window.history.replaceState(frmMainForm.CaptureState, '', URL);
    UpdateNav;
  end;

begin
  // Time this action
  ElapsedTime := Now;

  // Is this a valid SubForm?
  ValidSubForm := False;
  asm if (window.ValidSubForms.includes(SubForm)) { ValidSubForm = true; } end;
  if not(ValidSubForm) then
  begin
    LogAction('SubForm Not Found: '+SubForm, False);
    //Toast(DMIcons.Icon('Bug_Menu')+'ERROR: SubForm Error', 'SubForm Not Found: <br />[ '+SubForm+' ]',15000);
    exit;
  end;

  // Hide the old SubForm
  divSubForm := document.getElementById('divSubForm');
  asm divSubForm.style.setProperty('opacity','0','important'); end;
  asm await sleep(500); end;

  // Remove the old SubForm
  if Assigned(CurrentSubForm) then
  begin
    // Save to History
    if NewInstance then
    begin
      frmMainForm.Position := frmMainForm.Position + 1;
      window.history.pushState(frmMainForm.CaptureState, '', frmMainForm.URL);
    end;

    LogAction('Drop SubForm: '+CurrentSubFormName, False);
    CurrentSubForm.Close;
    asm
      document.getElementById('divSubForm').replaceChildren();
    end;
  end;


  // Note the new SubForm
  CurrentSubFormName := SubForm;
  asm
    document.getElementById('divSubForm').className = 'app-main '+SubForm;
  end;
  LogAction('Load SubForm: '+SubForm, False);

  // Launch SubForm
if (SubForm = 'AdministratorSub') then
  begin
//    CurrentSubFormNiceName := 'Admininistrator Dashboard';
//    CurrentSubFormShortName := 'AdminDash';
//    CurrentSubFormIcon := DMIcons.Icon('Administrator_Menu');
//    CurrentSubForm := TAdministratorSubForm.CreateNew(divSubForm.id, @AfterSubCreate);
  end;

  TLocalStorage.SetValue('Login.CurrentSubForm', SubForm);

end;


//====================================================================================================================//

procedure TfrmMainForm.SprachDaten_Laden( aID_Sprache : Integer =0 );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL : TStringList;
    aStream : TStream;
    i : Integer;
    aArray : TArray<string>;
begin

  //If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['MAIN',aID_Sprache] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL := TStringList.Create;
  aSL.Text := await( Crypt( sDaten)) ;

  tabSprachDaten.Close;
  tabSprachDaten.Open;

  If aSL.Count > 2 then
    For i := 2 to aSL.Count -1 Do
        Begin
         sTmp := aSL[i];
          aArray := sTmp.Split([';']);
          tabSprachDaten.Append;
          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
          tabSprachDaten.Post;
        End;

  aSL.Free;

  Form_Uebersetzen;

  //WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmMainForm.FormCloseQuery(Sender: TObject; var CanClose: Boolean);
begin
  inherited;
  Opt_Speichern;
end;

//====================================================================================================================//

procedure TfrmMainForm.Form_Uebersetzen;
begin

  console.Log( 'Form_Uebersetzen in TfrmMainForm');

  If not tabSprachDaten.Active then Exit;

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then mnDispo.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 20, [] ) then mnSystem.Caption   := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 30, [] ) then mnAbmelden.Caption := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then mnTransportauftraege.Caption   := tabSprachDatenBEGRIFF_UEB.AsString;

end;


procedure TfrmMainForm.mnInfoClick(Sender: TObject);
var sMsg : String;
    aModalResult : TModalResult;
begin
  inherited;

  sMsg := self.URL;

  await(TModalResult, MessageDlgAsync('Info: '+sMsg, mtInformation, [mbOK]));


end;

//====================================================================================================================//

procedure TfrmMainForm.LogAction(Action: String; Extend: Boolean);
var FilterAction: String;
    Module: String;
begin

  FilterAction := StringReplace(Action, chr(10), '', [rfReplaceAll]);
  FilterAction := StringReplace(FilterAction, chr(13), '', [rfReplaceAll]);
  FilterAction := StringReplace(FilterAction, '"', '''', [rfReplaceAll]);

  Module := StringReplace(CurrentFormName,'Form','',[]);
  if (CurrentSubFormName <> '')
  then Module := Module +'-'+StringReplace(CurrentSubFormName,'Sub','',[]);
  Module := Module.PadRight(30);

  // Log the action to a TStringList
  ActionLog.Add(FormatDateTime(App_LogDateTimeFormat,  TTimeZone.Local.ToUniversalTime(Now))+' UTC  ['+Module+']  '+FilterAction);
  ActionLogCurrent.Add(FormatDateTime(App_LogDateTimeFormat,  TTimeZone.Local.ToUniversalTime(Now))+' UTC  ['+Module+']  '+FilterAction);

  // Log to Console
//  console.Log(FilterAction);

  // Be mindful that generating log entries can reset the ActivityDetected state
  If Extend then ActivityDetected := True;

end;

//====================================================================================================================//

procedure TfrmMainForm.Loganzeigen1Click(Sender: TObject);
begin


end;

//====================================================================================================================//

procedure TfrmMainForm.Logout(Reason: String);
begin
  // Make sure these don't fire
  tmrJWTRenewal.Enabled := False;
  tmrJWTRenewalWarning.Enabled := False;


  if CurrentFormName <> 'Login' then
  begin

    LogAction('Logout: '+Reason, False);
    LogAction('Session Duration: '+FormatDateTime('h"h "m"m "s"s"', Now - App_Start), False);


    await(JSONRequest('ISystemService.Logout',[App_Session, ActionLogCurrent.Text]));

    JWT := '';
    TLocalStorage.SetValue('Login.CurrentForm','Login');
    TLocalStorage.RemoveKey('Login.JWT');
    TLocalStorage.RemoveKey('Login.Expiry');

//    asm
//      window.history.replaceState(null,null,window.location.href.split('#')[0]);
//      await sleep(1000);
//      divHost.style.setProperty('opacity','0');
//      await sleep(1000);
//    end;

    window.location.reload(true);
  end;

end;

procedure TfrmMainForm.MitarbeiterBelege1Click(Sender: TObject);
begin
  inherited;
  LoadForm('MitarbeiterBelege');
end;

//====================================================================================================================//

procedure TfrmMainForm.mnMitarbeiterClick(Sender: TObject);
begin
  LoadForm('Mitarbeiter');
end;

procedure TfrmMainForm.mnResponsivClick(Sender: TObject);
begin
  LoadForm('Responsiv');
end;

procedure TfrmMainForm.mnSchaedenClick(Sender: TObject);
begin
  inherited;
  LoadForm('Schaeden');
end;

//====================================================================================================================//

procedure TfrmMainForm.NavHistoryBack;
begin
  window.history.back;
end;

procedure TfrmMainForm.NavHistoryForward;
begin
  window.history.forward;
end;

procedure TfrmMainForm.ouren1Click(Sender: TObject);
begin
  inherited;
   LoadForm('Tour');
end;

//====================================================================================================================//

procedure TfrmMainForm.Set_BenutzerInfo;
begin

  If StrToIntDef(BenutzerLftID,0) > 0 then
       lbBenutzer.Caption := '  '+ BenutzerLftName
  Else lbBenutzer.Caption := '  '+ BenutzerMaZuname+', '+ BenutzerMaVorname + ' - '+self.sAktFahrzeug ;

end;

//====================================================================================================================//

procedure TfrmMainForm.ProcessJWT(aJWT: String);
var JWTClaims: TJSONObject;
     i : Integer;
begin


  JWT := aJWT;

  // Get JSON Claims from JWT
  JWTClaims := TJSONObject.ParseJSONValue(Window.atob(Copy(JWT, Pos('.',JWT)+1, LastDelimiter('.',JWT)-Pos('.',JWT)-1))) as TJSONObject;

  // Extract user information
  BenutzerMaVorname  :=  (JWTClaims.GetValue('fnm') as TJSONString).Value;
  BenutzerMaNr       :=  (JWTClaims.GetValue('mnm') as TJSONString).Value;
  BenutzerMaZuname   :=  (JWTClaims.GetValue('lnm') as TJSONString).Value;
  BenutzerLftID      :=  (JWTClaims.GetValue('lft') as TJSONString).Value;
  BenutzerLftName    :=  (JWTClaims.GetValue('lfn') as TJSONString).Value;
  MandantName        :=  (JWTClaims.GetValue('man') as TJSONString).Value;

  User_EMail   :=  (JWTClaims.GetValue('eml') as TJSONString).Value;
  User_Account :=  (JWTClaims.GetValue('anm') as TJSONString).Value;

//  If StrToIntDef(BenutzerLftID,0) > 0 then
//       lbBenutzer.Caption := '  '+ BenutzerLftName
//  Else lbBenutzer.Caption := '  '+ BenutzerMaZuname+', '+ BenutzerMaVorname + ' - '+self.sAktFahrzeug ;
  Set_BenutzerInfo;

  lbWebTitel.Caption := '  SpediFucs - '+ MandantName;



  // Set renewal to one minute before expiration
  JWT_Expiry := UnixToDateTime((JWTClaims.GetValue('exp') as TJSONNumber).AsInt);
  tmrJWTRenewal.Enabled := False;
  tmrJWTRenewal.Interval := MillisecondsBetween(JWT_Expiry, TTimeZone.Local.ToUniversalTime(Now)) - 30000;
  tmrJWTRenewalWarning.Interval := MillisecondsBetween(JWT_Expiry, TTimeZone.Local.ToUniversalTime(Now)) - 90000;

  // If it has already expired, then not much point in continuing?
  if tmrJWTRenewal.Interval <= 0 then
  begin
    Logout('JWT Expired')
  end
  else
  begin
    tmrJWTRenewal.Enabled := True;
    tmrJWTRenewalWarning.Enabled := True;

    if Remember then
    begin
      TLocalStorage.SetValue('Login.JWT', frmMainForm.JWT);
      TLocalStorage.SetValue('Login.Expiry', FloatToStr(frmMainForm.JWT_Expiry));
    end;

    // Extract Roles
//    Role_Administrator := False;
//    i := 0;
//    while i < User_Roles.Count do
//    begin
//      if User_Roles[i] = '1' then Role_Administrator := True;
//      i := i + 1;
//    end;

    LogAction('Processing Token', False);
    //LogAction( frmMainForm.JWT, False );
    LogAction(' -> Name: '+BenutzerMaVorname+' '+BenutzerMaZuname, False);
    LogAction(' -> EMail: '+User_Email, False);
//    LogAction(' -> Roles: '+User_Roles.CommaText, False);
//    LogAction(' -> Administrator: '+BoolToStr(Role_Administrator,True), False);
    LogAction(' -> Expires: '+(JWTClaims.GetValue('unt') as TJSONString).Value,False);
    LogAction(' -> Remaining: '+FormatDateTime('n"m "s"s"',(JWT_Expiry - TTimeZone.Local.ToUniversalTime(Now))),False);
    LogAction('Token Processed', False);

  end;


end;

//====================================================================================================================//

procedure TfrmMainForm.mnTransportauftraegeClick(Sender: TObject);
begin
//ErzeugeTau;
   LoadForm('Tau');
end;

procedure TfrmMainForm.mnUrlaubClick(Sender: TObject);
begin
  inherited;
   LoadForm('UrlbAntrag');
end;

//====================================================================================================================//

procedure TfrmMainForm.mnZeitbuchungenClick(Sender: TObject);
begin
  inherited;
   LoadForm('Zeitbuchungen');
end;

//====================================================================================================================//

procedure TfrmMainForm.RecordSession;
begin
  if RecordingSession = False then
  begin
    RecordingSession := True;
    asm
      var Icon = pas.UnitIcons.DMIcons.Lookup;
      btnRecording.innerHTML = Icon['Record']+'00:00:00';
      btnRecord.innerHTML = Icon['Record']+'Stop Recording';
      btnRecording.classList.remove('d-none');
      pas.UnitMain.MainForm.CaptureData = [];
    end;
    frmMainForm.tmrCapture.Enabled := True;
  end
  else
  begin
    RecordingSession := False;
    asm
      var Icon = pas.UnitIcons.DMIcons.Lookup;
      btnRecording.classList.add('d-none');
      btnRecord.innerHTML = Icon['Record']+'Start Recording';
    end;
    frmMainForm.tmrCapture.Enabled := False;
  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.tmrCaptureTimer(Sender: TObject);
begin
  asm
    // Maximum capture - 600 frames (10m @ 1 fps)
    if (pas.UnitMain.MainForm.CaptureData.length < 600) {
      modernScreenshot.domToPng(document.querySelector('#divHost'), {scale:1.0, width: Math.ceil(window.innerWidth / 2) * 2, height: Math.ceil(window.innerHeight / 2) * 2 }).then(dataURI => {
//        console.image(dataURI,0.5);
        pas.UnitMain.MainForm.CaptureData.push(dataURI);
        var icon = pas.UnitIcons.DMIcons.Lookup;
        var rectime = new Date(1000 * pas.UnitMain.MainForm.CaptureData.length).toISOString().substr(11, 8);
        btnRecording.innerHTML = icon['Record']+rectime;
      });
    }
  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.tmrJWTRenewalTimer(Sender: TObject);
var
  ResponseString: String;
  ActionLogSend: String;
begin
  tmrJWTRenewal.Enabled := False;

  ActionLogSend := ActionLogCurrent.Text;
  ActionLogCurrent.Text := '';

  // Renew JWT if there has been activity of some kind
  if ActivityDetected then
  begin
    ResponseString := await(JSONRequest('ISystemService.Renew',[App_Session, ActionLogSend]));
    if Copy(ResponseString,1,6) =  'Bearer' then
    begin
      LogAction('Login Renewed', False);
      ProcessJWT(ResponseString);
      ActivityDetected := False;
    end
    else
    begin
    // Otherwise perform an automatic logout of this session
      LogAction('Login NOT Renewed', False);
      Logout('NoRenewal');
    end
  end
  else
  begin
    Logout('Inactivity');
  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.tmrJWTRenewalWarningTimer(Sender: TObject);
begin
  tmrJWTRenewalWarning.Enabled := False;
  if not(ActivityDetected)
  then Toast('Auto Logout','No activity has been detected.<br />Auto Logout in $S seconds.', 60000);
end;

//====================================================================================================================//

procedure TfrmMainForm.Toast(Header, Body: String; Timeout: Integer);
begin
  // Want ID to be unique
//  ToastCount := ToastCount + 1;

  asm
    // Create Toast
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('id','toast'+this.ToastCount);
    toast.setAttribute('role','alert');
    toast.setAttribute('aria-live','assertive');
    toast.setAttribute('aria-atomic','true');
    toast.setAttribute('data-bs-delay', Timeout);
    toast.setAttribute('countdown',parseInt(2*Timeout/1000));

    // Create Toast Header
    var toasth = document.createElement('div');
    toasth.className = 'toast-header bg-danger text-white pb-3 position-relative';
    toasth.innerHTML = '<div style="position:absolute; border-radius: var(--custom-rounding); z-index: 2; display:block; top:37px; left:4px; width:98%; height:5px; background: var(--bs-danger);"></div>'+
                       '<div style="position:absolute; border-radius: var(--custom-rounding); z-index: 1; display:block; top:36px; left:3px; width:98%; height:7px; background: var(--bs-dark);"></div>'+
                       '<strong class="me-auto">'+Header+'</strong>'+
                       '<small class="text-light">just now</small>'+
                       '<button type="button" onclick="pas.UnitMain.MainForm.ActivityDetected = true;"; class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>';

    // Create Toast Body
    var toastb = document.createElement('div');
    toastb.className = 'toast-body';
    toastb.innerHTML = Body.replace('$S',parseInt(Timeout/1000));

    // Make Toast
    toast.appendChild(toasth);
    toast.appendChild(toastb);
    divToasts.appendChild(toast);

    // Add countdown timer
    const toastc = setInterval(function() {
      if (((Timeout == 60000) && (pas.UnitMain.MainForm.ActivityDetected == true)) || ((toast.getAttribute('countdown') | 0) <= 0)) {
        clearInterval(toastc);
        toast.remove();
      }
      else {
        toast.setAttribute('countdown',toast.getAttribute('countdown')-1);
        toast.lastElementChild.innerHTML = Body.replace('$S',parseInt(toast.getAttribute('countdown')/2));
        toast.firstElementChild.firstElementChild.style.setProperty('width', parseInt(98*toast.getAttribute('countdown')/(Timeout/500))+'%');
      }
    },500);

    // Show Toast
    var newtoast = new bootstrap.Toast(toast).show();

  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.UpdateNav;
begin
  asm
//console.log('Position = '+this.Position);
//console.log('Start = '+this.StartPosition);
//console.log('History = '+window.history.length);
//console.log(' ');

    var backbtns = document.getElementsByClassName('nav-history-back');
    if (this.Position <= (this.StartPosition+1)) {
      for (var i = 0; i < backbtns.length; i++) {
        backbtns[i].setAttribute('disabled','');
      }
    } else {
      for (var i = 0; i < backbtns.length; i++) {
        backbtns[i].removeAttribute('disabled');
      }
    }

    var forwardbtns = document.getElementsByClassName('nav-history-forward');
    if (this.Position == window.history.length) {
      for (var i = 0; i < forwardbtns.length; i++) {
        forwardbtns[i].setAttribute('disabled','');
      }
    } else {
      for (var i = 0; i < forwardbtns.length; i++) {
        forwardbtns[i].removeAttribute('disabled');
      }
    }
  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.mnAbmeldenClick(Sender: TObject);
begin
  Logout('Browser geschlossen' );
end;

//====================================================================================================================//

procedure TfrmMainForm.mnAktivesFahrzeugClick(Sender: TObject);
var iID , iTab  : Integer;
    sBez: String;
    aModalResult : TModalResult;
begin
  inherited;

  iTab := c_Fzg;
  iID := self.iID_AktFzg;
  sBez := '';

  aModalResult := await( TModalResult, Get_Stammdaten2( iTab, iID, sBez ) );

  If aModalResult = mrOK then
    If iID <> 0 then
      Begin
        sAktFahrzeug := sBez;
        iID_AktFzg := iID;

        Opt_Speichern;
        Set_BenutzerInfo;
      End;


EXIT;

  Try
    await( Get_Stammdaten( iTab, iID, sBez ) );
  Finally
   console.log('iID: '+inttostr(iID)+' sBez: '+sBez );

    If iID <> 0 then
      Begin
        sAktFahrzeug := sBez;
        iID_AktFzg := iID;

        Opt_Speichern;
        Set_BenutzerInfo;
      End;
  End;
end;

//====================================================================================================================//

procedure TfrmMainForm.mnMaterialBestellungenClick(Sender: TObject);
begin
  inherited;
  LoadForm('MaterialBestellungen');
end;

procedure TfrmMainForm.btnViewerCloseClick(Sender: TObject);
begin
  window.history.back;
end;

//====================================================================================================================//

procedure TfrmMainForm.mnAbschlussClick(Sender: TObject);
begin
  LoadForm('Abschluss');
end;

//====================================================================================================================//

procedure TfrmMainForm.mnAbwesenheitsVerwaltungClick(Sender: TObject);
begin
  LoadForm('AbwVerwaltung');
end;

//====================================================================================================================//

procedure TfrmMainForm.mnBuchungenClick(Sender: TObject);
begin
  LoadForm('Buchungen');
end;

//====================================================================================================================//

procedure TfrmMainForm.mnFormSchliessenClick(Sender: TObject);
begin
  inherited;

  frmMainForm.LoadForm('frmMainForm');
  Exit;

end;

procedure TfrmMainForm.mnFsKontrollenClick(Sender: TObject);
begin
  LoadForm('FsKontrollen');

end;

//====================================================================================================================//

function TfrmMainForm.CaptureState: JSValue;
begin
  Result := nil;
  // Return state of some kind
  asm
    Result = {
      "Position": this.Position,
      "URL": this.URL,
      "Form": this.CurrentFormName,
      "SubForm": this.CurrentSubFormName,
    }
  end;
end;

//====================================================================================================================//

procedure TfrmMainForm.divViewerImageClick(Sender: TObject);
begin
  window.history.back;
end;

//====================================================================================================================//

function TfrmMainForm.JSONRequest(Endpoint: String; Params: array of JSValue): String;
var
  ClientConn: TXDataWebClient;
  Response: TXDataClientResponse;
  Blob: JSValue;
  ErrorCode: String;
  ErrorMessage: String;
  Elapsed: TDateTime;
begin
  Elapsed := Now;
  Result := '';
  LogAction('Requested: '+Endpoint, False);

  await(XDataConnect);
  if (XdataConn.Connected) then
  begin
    try
      ClientConn := TXDataWebClient.Create(nil);
      ClientConn.Connection := XDataConn;
      Response := await(ClientConn.RawInvokeAsync(Endpoint, Params));

      Blob := Response.Result;
      asm Result = await Blob.text(); end;

    except on E: Exception do
      begin
        // Get the error message we created in XData
        asm {
          var ErrorDetail = JSON.parse( await E.FErrorResult.FResponse.$o.FXhr.response.text() );
          ErrorCode = ErrorDetail.error.code;
          ErrorMessage = ErrorDetail.error.message;
        } end;

        // Log the error, but leave out the URI (because it includes the password)
        LogAction('ERROR Request Exception Received From'+Endpoint, False);
        LogAction(' --> ['+E.ClassName+']', False);
        LogAction(' --> '+Copy(E.Message,1,Pos('Uri:',E.Message)-2), False);
        LogAction(' --> '+Copy(E.Message,Pos('Status code:',E.Message),16), False);
        LogAction(' --> '+ErrorCode, False);
        LogAction(' --> '+ErrorMessage, False);

        // Will tamp these down a bit once we get a better feel for the kinds of errors
        // that come up regularly.
        Toast('Unexpected Error',
          '[ '+E.ClassName+' ] '+Endpoint+'<br />'+
          Copy(E.Message,1,Pos('Uri:',E.Message)-2)+'<br />'+
          Copy(E.Message,Pos('Status code:',E.Message),16)+'<br />'+
          ErrorCode+'<br />'+
          ErrorMessage
        ,45000);

      end;
    end;
  end;

  LogAction('Responded: '+Endpoint+' ('+IntToStr(MillisecondsBetween(Now, Elapsed))+'ms)', False);
  PreventCompilerHint(Blob);
end;

//====================================================================================================================//

procedure TfrmMainForm.XDataConnConnect(Sender: TObject);
begin


end;

//====================================================================================================================//

procedure TfrmMainForm.XDataConnect( bTest : Boolean=False);
var  ElapsedTime: TDateTime;
     sTmp : String;
begin

  ElapsedTime := Now;

  Console.log('XDataConnect - Start');

  If bTest then
       Console.log('TEST-XDataConnect  - Start  ')
  Else Console.log('XDataConnect - Start');

  If not(XDataConn.Connected) then
    Begin

      // Should be updated to point at our XData server, wherever it may be
      XDataConn.URL := g_XDataServer_URL;


      // Try and establish a connection to the server
      try
        sTmp := 'Verbinde zu: '+XDataConn.URL;
        LogAction(sTmp, False);
        Console.log(sTmp);
        await(XDataConn.OpenAsync);
        sTmp := 'Verbindung hergestellt: ('+IntToStr(MillisecondsBetween(Now, ElapsedTime))+'ms)';
        LogAction(sTmp, False);
        Console.log(sTmp);
      except on E: Exception do
        begin
          sTmp := 'Verbindung nicht möglich: '+XDataConn.URL+' --> ['+E.ClassName+'] '+E.Message;
          Console.log(sTmp);
          LogAction( sTmp, False);
        end;
      end;
    End
  Else Console.log('XDataConnect - bereits verbunden mit: '+XDataConn.URL);


  Console.log('XDataConnect - Ende');

end;

//====================================================================================================================//

procedure TfrmMainForm.XDataConnRequest(Args: TXDataWebConnectionRequest);
begin

  Args.Request.Headers.SetValue('Authorization', JWT);


end;

//====================================================================================================================//

function TfrmMainForm.XDataLogin( aUsername, aPassword: String ):String;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    NewJWT, sUser, sPasswort : String;
  ElapsedTime: TDateTime;
  ErrorCode: String;
  ErrorMessage: String;
begin

  Console.Log('XDataLogin- Start');

  ElapsedTime := Now;
  NewJWT := '';
  ErrorCode := '';
  ErrorMessage := '';

  sUser     := await( Crypt( aUsername ));
  sPasswort := await( Crypt( aPassword ));

  // Verbinden, falls getrennt
  await( XDataConnect );



  LogAction(' --> TimeZone: '+App_TZ, False);

  If (XDataConn.Connected) then
  begin
    try

      ClientConn := TXDataWebClient.Create(nil);
      ClientConn.Connection := XDataConn;

      Response := await(ClientConn.RawInvokeAsync('ISystemService.Login', [ sUser, sPasswort, 'Testing', App_TZ ]));

      Blob := Response.Result;
      asm NewJWT = await Blob.text(); end;

    except on E: Exception do
      begin
        // Get the error message we created in XData
        asm {
          var ErrorDetail = JSON.parse( await E.FErrorResult.FResponse.$o.FXhr.response.text() );
          ErrorCode = ErrorDetail.error.code;
          ErrorMessage = ErrorDetail.error.message;
        } end;

        // Log the error, but leave out the URI (because it includes the password)
        LogAction('Login Exception:', False);
        LogAction(' --> ['+E.ClassName+']', False);
        LogAction(' --> '+Copy(E.Message,1,Pos('Uri:',E.Message)-2), False);
        LogAction(' --> '+Copy(E.Message,Pos('Status code:',E.Message),16), False);
        LogAction(' --> '+ErrorCode, False);
        LogAction(' --> '+ErrorMessage, False);

      end;
    end;
  end; // If (XDataConn.Connected) then

  Console.Log('>>> Weve got a JWT');


  // We've got a JWT
  if Pos('Bearer ', NewJWT) = 1 then
  begin
    // How long did it take?
    LogAction('Login Successful ('+IntToStr(MilliSecondsBetween(Now, ElapsedTime))+'ms)', False);

    // Do stuff with the JWT
    ProcessJWT(NewJWT);

    // All done
    Result := 'Success';
    LoggedIn := True;

    //Console.Log('JWT: '+NewJWT);

  end
  else
  begin
    LoggedIn := False;
    Result := ErrorCode+' / '+ErrorMessage;
  end;

  Console.Log('XDataLogin- Ende');

  PreventCompilerHint(Blob);
end;

//====================================================================================================================//

procedure TfrmMainForm.PlaybackSession;
var
  FrameCount: Integer;
  PlaybackRate: Double;
begin

  asm FrameCount = pas.UnitMain.MainForm.CaptureData.length; end;

  if FrameCount = 0 then
  begin

  end
  else
  begin

    PlaybackRate := 1;

    asm
      // Load and initialize ffmpeg
      const { createFFmpeg, fetchFile } = FFmpeg;
      const ffmpeg = createFFmpeg({
//        log: true,
        mainName: 'main',
        corePath: 'https://cdn.jsdelivr.net/npm/@ffmpeg/core-st@0.11.1/dist/ffmpeg-core.js'
      });
      await ffmpeg.load();


      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      ffmpeg.setProgress(async function({ ratio })  {
        console.log('FFmpeg Progress: '+ratio);
      });


      const image2video = async () => {

        // Add image files to ffmpeg internal filesystem
        FrameCount = pas.UnitMain.MainForm.CaptureData.length;
        for (let i = 0; i < FrameCount; i += 1) {
          const num = `000${i}`.slice(-4);
          ffmpeg.FS('writeFile', 'tmp.'+num+'.png', await fetchFile(dataURLtoFile(pas.UnitMain.MainForm.CaptureData[i],'frame-'+i+'.png')));
        }

        // Perform the conversion the conversion
        await ffmpeg.run('-framerate', String(PlaybackRate), '-pattern_type', 'glob', '-i', '*.png','-c:v', 'libx264', '-pix_fmt', 'yuv420p', 'out.mp4');

        // Get the resulting video file
        const data = ffmpeg.FS('readFile', 'out.mp4');

        // Delete image files from ffmpeg internal filesystem
        for (let i = 0; i < FrameCount; i += 1) {
          const num = `000${i}`.slice(-4);
          ffmpeg.FS('unlink', 'tmp.'+num+'.png');
        }
        ffmpeg.exit;

        // Create a place to show the video
        const video = document.createElement('video');

        // Load the video file into the page element
        video.src = URL.createObjectURL(new Blob([data.buffer], { type: 'video/mp4' }));

        // Set some attributes
        video.id = "video";
        video.controls = true;
        video.loop = true;

        // Set some styles
        video.style.setProperty('position','fixed');
        video.style.setProperty('left','0px');
        video.style.setProperty('top','0px');
        video.style.setProperty('width','100%');
        video.style.setProperty('height','100%');
        video.style.setProperty('z-index','1000000');

        // Add to the page
        document.body.appendChild(video);

        // Load and start playing the video
        video.load();
        video.play();

        // Wait for a double-click to unload the video
        video.addEventListener('dblclick',function() {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.src = '';
          video.srcObject = null;
          video.remove()
        });

      }

      image2video();

    end;
  end;
end;


procedure TfrmMainForm.StopLinkerRemoval(P: Pointer);                          begin end;
procedure TfrmMainForm.PreventCompilerHint(H: TJSHTMLElement);       overload; begin end;
procedure TfrmMainForm.PreventCompilerHint(I: integer);              overload; begin end;
procedure TfrmMainForm.PreventCompilerHint(J: JSValue);              overload; begin end;
procedure TfrmMainForm.PreventCompilerHint(S: string);               overload; begin end;


procedure TfrmMainForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMenu := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  lbWebTitel := TLabel.Create(Self);
  lbBenutzer := TLabel.Create(Self);
  WebSplitter1 := TSplitter.Create(Self);
  MainScrollBox := TScrollBox.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  XDataConn := TXDataWebConnection.Create(Self);
  tmrJWTRenewal := TTimer.Create(Self);
  tmrJWTRenewalWarning := TTimer.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  tmrCapture := TTimer.Create(Self);
  mMainmenu := TMainMenu.Create(Self);
  mnDispo := TMenuItem.Create(Self);
  mnTransportauftraege := TMenuItem.Create(Self);
  ouren1 := TMenuItem.Create(Self);
  mnResponsiv := TMenuItem.Create(Self);
  mnFahrzeuge := TMenuItem.Create(Self);
  mnAbfKontrolle := TMenuItem.Create(Self);
  mnSchaeden := TMenuItem.Create(Self);
  Position1 := TMenuItem.Create(Self);
  mnMitarbeiter := TMenuItem.Create(Self);
  mnFsKontrollen := TMenuItem.Create(Self);
  mnMaterialBestellungen := TMenuItem.Create(Self);
  MitarbeiterBelege1 := TMenuItem.Create(Self);
  mnUrlaub := TMenuItem.Create(Self);
  mnZeitbuchungen := TMenuItem.Create(Self);
  mnSystem := TMenuItem.Create(Self);
  mnAktivesFahrzeug := TMenuItem.Create(Self);
  mnFormSchliessen := TMenuItem.Create(Self);
  Passwortndern1 := TMenuItem.Create(Self);
  mnInfo := TMenuItem.Create(Self);
  mnAbmelden := TMenuItem.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);
  tabAnwAbw := TXDataWebDataSet.Create(Self);
  tabAnwAbwANWABW_NR := TIntegerField.Create(Self);
  tabAnwAbwANWABW_BEZ := TStringField.Create(Self);
  tabAnwAbwANWABW_TYP := TIntegerField.Create(Self);
  tabAnwAbwANWABW_KURZ := TStringField.Create(Self);
  tabAnwAbwANWABW_FARBE := TStringField.Create(Self);

  pnlMenu.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  lbWebTitel.BeforeLoadDFMValues;
  lbBenutzer.BeforeLoadDFMValues;
  WebSplitter1.BeforeLoadDFMValues;
  MainScrollBox.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  XDataConn.BeforeLoadDFMValues;
  tmrJWTRenewal.BeforeLoadDFMValues;
  tmrJWTRenewalWarning.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  tmrCapture.BeforeLoadDFMValues;
  mMainmenu.BeforeLoadDFMValues;
  mnDispo.BeforeLoadDFMValues;
  mnTransportauftraege.BeforeLoadDFMValues;
  ouren1.BeforeLoadDFMValues;
  mnResponsiv.BeforeLoadDFMValues;
  mnFahrzeuge.BeforeLoadDFMValues;
  mnAbfKontrolle.BeforeLoadDFMValues;
  mnSchaeden.BeforeLoadDFMValues;
  Position1.BeforeLoadDFMValues;
  mnMitarbeiter.BeforeLoadDFMValues;
  mnFsKontrollen.BeforeLoadDFMValues;
  mnMaterialBestellungen.BeforeLoadDFMValues;
  MitarbeiterBelege1.BeforeLoadDFMValues;
  mnUrlaub.BeforeLoadDFMValues;
  mnZeitbuchungen.BeforeLoadDFMValues;
  mnSystem.BeforeLoadDFMValues;
  mnAktivesFahrzeug.BeforeLoadDFMValues;
  mnFormSchliessen.BeforeLoadDFMValues;
  Passwortndern1.BeforeLoadDFMValues;
  mnInfo.BeforeLoadDFMValues;
  mnAbmelden.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  tabAnwAbw.BeforeLoadDFMValues;
  tabAnwAbwANWABW_NR.BeforeLoadDFMValues;
  tabAnwAbwANWABW_BEZ.BeforeLoadDFMValues;
  tabAnwAbwANWABW_TYP.BeforeLoadDFMValues;
  tabAnwAbwANWABW_KURZ.BeforeLoadDFMValues;
  tabAnwAbwANWABW_FARBE.BeforeLoadDFMValues;
  try
    Name := 'frmMainForm';
    Left := 0;
    Top := 0;
    Caption := 'SpediFucs';
    Color := 16776441;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Verdana';
    Font.Style := [];
    Menu := mMainmenu;
    Visible := True;
    SetEvent(Self, 'OnClick', 'WebFormClick');
    SetEvent(Self, 'OnCloseQuery', 'FormCloseQuery');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnKeyDown', 'WebFormKeyDown');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlMenu.SetParentComponent(Self);
    pnlMenu.Name := 'pnlMenu';
    pnlMenu.Left := 0;
    pnlMenu.Top := 50;
    pnlMenu.Width := 1204;
    pnlMenu.Height := 40;
    pnlMenu.Align := alTop;
    pnlMenu.ChildOrder := 3;
    pnlMenu.Color := 12021811;
    pnlMenu.TabOrder := 0;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 0;
    pnlStatus.Width := 1204;
    pnlStatus.Height := 50;
    pnlStatus.Align := alTop;
    pnlStatus.ChildOrder := 11;
    pnlStatus.Color := 12021811;
    pnlStatus.Font.Charset := DEFAULT_CHARSET;
    pnlStatus.Font.Color := clWhite;
    pnlStatus.Font.Height := -15;
    pnlStatus.Font.Name := 'Verdana';
    pnlStatus.Font.Style := [fsBold];
    pnlStatus.ParentFont := False;
    pnlStatus.TabOrder := 1;
    lbWebTitel.SetParentComponent(pnlStatus);
    lbWebTitel.Name := 'lbWebTitel';
    lbWebTitel.Left := 0;
    lbWebTitel.Top := 0;
    lbWebTitel.Width := 1204;
    lbWebTitel.Height := 25;
    lbWebTitel.Align := alTop;
    lbWebTitel.Alignment := taCenter;
    lbWebTitel.AutoSize := False;
    lbWebTitel.Caption := 'SpediFucs';
    lbWebTitel.Font.Charset := DEFAULT_CHARSET;
    lbWebTitel.Font.Color := clWhite;
    lbWebTitel.Font.Height := -19;
    lbWebTitel.Font.Name := 'Verdana';
    lbWebTitel.Font.Style := [fsBold];
    lbWebTitel.HeightPercent := 100.000000000000000000;
    lbWebTitel.Layout := tlCenter;
    lbWebTitel.ParentFont := False;
    lbWebTitel.WidthPercent := 100.000000000000000000;
    lbBenutzer.SetParentComponent(pnlStatus);
    lbBenutzer.Name := 'lbBenutzer';
    lbBenutzer.Left := 0;
    lbBenutzer.Top := 25;
    lbBenutzer.Width := 1204;
    lbBenutzer.Height := 25;
    lbBenutzer.Align := alClient;
    lbBenutzer.Alignment := taCenter;
    lbBenutzer.Caption := ' Benutzer: --';
    lbBenutzer.Font.Charset := DEFAULT_CHARSET;
    lbBenutzer.Font.Color := clWhite;
    lbBenutzer.Font.Height := -13;
    lbBenutzer.Font.Name := 'Verdana';
    lbBenutzer.Font.Style := [fsBold];
    lbBenutzer.HeightPercent := 100.000000000000000000;
    lbBenutzer.Layout := tlCenter;
    lbBenutzer.ParentFont := False;
    lbBenutzer.WidthPercent := 100.000000000000000000;
    WebSplitter1.SetParentComponent(Self);
    WebSplitter1.Name := 'WebSplitter1';
    WebSplitter1.Left := 1199;
    WebSplitter1.Top := 105;
    WebSplitter1.Width := 5;
    WebSplitter1.Height := 501;
    WebSplitter1.Align := alRight;
    WebSplitter1.ChildOrder := 4;
    WebSplitter1.Color := clBtnFace;
    MainScrollBox.SetParentComponent(Self);
    MainScrollBox.Name := 'MainScrollBox';
    MainScrollBox.Left := 0;
    MainScrollBox.Top := 105;
    MainScrollBox.Width := 1199;
    MainScrollBox.Height := 501;
    MainScrollBox.Align := alClient;
    MainScrollBox.BorderStyle := bsSingle;
    MainScrollBox.ChildOrder := 5;
    MainScrollBox.Color := 16776441;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 90;
    WebPanel1.Width := 1204;
    WebPanel1.Height := 15;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 3;
    WebPanel1.Color := 12021811;
    WebPanel1.TabOrder := 4;
    XDataConn.SetParentComponent(Self);
    XDataConn.Name := 'XDataConn';
    SetEvent(XDataConn, Self, 'OnConnect', 'XDataConnConnect');
    SetEvent(XDataConn, Self, 'OnRequest', 'XDataConnRequest');
    XDataConn.Left := 480;
    XDataConn.Top := 183;
    tmrJWTRenewal.SetParentComponent(Self);
    tmrJWTRenewal.Name := 'tmrJWTRenewal';
    tmrJWTRenewal.Enabled := False;
    SetEvent(tmrJWTRenewal, Self, 'OnTimer', 'tmrJWTRenewalTimer');
    tmrJWTRenewal.Left := 120;
    tmrJWTRenewal.Top := 408;
    tmrJWTRenewalWarning.SetParentComponent(Self);
    tmrJWTRenewalWarning.Name := 'tmrJWTRenewalWarning';
    tmrJWTRenewalWarning.Enabled := False;
    SetEvent(tmrJWTRenewalWarning, Self, 'OnTimer', 'tmrJWTRenewalWarningTimer');
    tmrJWTRenewalWarning.Left := 136;
    tmrJWTRenewalWarning.Top := 504;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Left := 608;
    WebHttpRequest1.Top := 255;
    tmrCapture.SetParentComponent(Self);
    tmrCapture.Name := 'tmrCapture';
    tmrCapture.Enabled := False;
    SetEvent(tmrCapture, Self, 'OnTimer', 'tmrCaptureTimer');
    tmrCapture.Left := 48;
    tmrCapture.Top := 456;
    mMainmenu.SetParentComponent(Self);
    mMainmenu.Name := 'mMainmenu';
    mMainmenu.Tag := 40;
    mMainmenu.Appearance.BackgroundColor := 16574684;
    mMainmenu.Appearance.HamburgerMenu.Caption := 'Menu';
    mMainmenu.Appearance.HamburgerMenu.CaptionColor := clBlack;
    mMainmenu.Appearance.HamburgerMenu.BackgroundColor := 16370864;
    mMainmenu.Appearance.HamburgerMenu.ResponsiveMaxWidth := 600;
    mMainmenu.Appearance.HoverFontColor := 15400959;
    mMainmenu.Appearance.ImageSize := 20;
    mMainmenu.Appearance.SubmenuIndicator := '&#9658;';
    mMainmenu.Container := pnlMenu;
    mMainmenu.Font.Charset := DEFAULT_CHARSET;
    mMainmenu.Font.Color := clWindowText;
    mMainmenu.Font.Height := -11;
    mMainmenu.Font.Name := 'Verdana';
    mMainmenu.Font.Style := [];
    mMainmenu.ParentFont := False;
    mMainmenu.Visible := False;
    mMainmenu.Left := 368;
    mMainmenu.Top := 184;
    mnDispo.SetParentComponent(mMainmenu);
    mnDispo.Name := 'mnDispo';
    mnDispo.Caption := 'Disposition';
    mnDispo.Enabled := False;
    mnDispo.Visible := False;
    mnTransportauftraege.SetParentComponent(mnDispo);
    mnTransportauftraege.Name := 'mnTransportauftraege';
    mnTransportauftraege.Tag := 40;
    mnTransportauftraege.Caption := 'Transportauftr'#228'ge';
    SetEvent(mnTransportauftraege, Self, 'OnClick', 'mnTransportauftraegeClick');
    ouren1.SetParentComponent(mnDispo);
    ouren1.Name := 'ouren1';
    ouren1.Caption := 'Touren';
    SetEvent(ouren1, Self, 'OnClick', 'ouren1Click');
    mnResponsiv.SetParentComponent(mnDispo);
    mnResponsiv.Name := 'mnResponsiv';
    mnResponsiv.Caption := 'Responsiv';
    mnResponsiv.Visible := False;
    SetEvent(mnResponsiv, Self, 'OnClick', 'mnResponsivClick');
    mnFahrzeuge.SetParentComponent(mMainmenu);
    mnFahrzeuge.Name := 'mnFahrzeuge';
    mnFahrzeuge.Caption := 'Fahrzeuge';
    mnFahrzeuge.Enabled := False;
    mnFahrzeuge.Visible := False;
    mnAbfKontrolle.SetParentComponent(mnFahrzeuge);
    mnAbfKontrolle.Name := 'mnAbfKontrolle';
    mnAbfKontrolle.Caption := 'Abfahrtkontrolle';
    SetEvent(mnAbfKontrolle, Self, 'OnClick', 'mnAbfKontrolleClick');
    mnSchaeden.SetParentComponent(mnFahrzeuge);
    mnSchaeden.Name := 'mnSchaeden';
    mnSchaeden.Caption := 'Sch'#228'den';
    SetEvent(mnSchaeden, Self, 'OnClick', 'mnSchaedenClick');
    Position1.SetParentComponent(mnFahrzeuge);
    Position1.Name := 'Position1';
    Position1.Caption := 'Position';
    SetEvent(Position1, Self, 'OnClick', 'Position1Click');
    mnMitarbeiter.SetParentComponent(mMainmenu);
    mnMitarbeiter.Name := 'mnMitarbeiter';
    mnMitarbeiter.Caption := 'Mitarbeiter';
    mnMitarbeiter.Enabled := False;
    mnMitarbeiter.Visible := False;
    mnFsKontrollen.SetParentComponent(mnMitarbeiter);
    mnFsKontrollen.Name := 'mnFsKontrollen';
    mnFsKontrollen.Caption := 'F'#252'hrerscheinkontrollen';
    SetEvent(mnFsKontrollen, Self, 'OnClick', 'mnFsKontrollenClick');
    mnMaterialBestellungen.SetParentComponent(mnMitarbeiter);
    mnMaterialBestellungen.Name := 'mnMaterialBestellungen';
    mnMaterialBestellungen.Caption := 'Material-Bestellungen';
    SetEvent(mnMaterialBestellungen, Self, 'OnClick', 'mnMaterialBestellungenClick');
    MitarbeiterBelege1.SetParentComponent(mnMitarbeiter);
    MitarbeiterBelege1.Name := 'MitarbeiterBelege1';
    MitarbeiterBelege1.Caption := 'Mitarbeiter-Belege';
    SetEvent(MitarbeiterBelege1, Self, 'OnClick', 'MitarbeiterBelege1Click');
    mnUrlaub.SetParentComponent(mnMitarbeiter);
    mnUrlaub.Name := 'mnUrlaub';
    mnUrlaub.Caption := 'Urlaub';
    SetEvent(mnUrlaub, Self, 'OnClick', 'mnUrlaubClick');
    mnZeitbuchungen.SetParentComponent(mnMitarbeiter);
    mnZeitbuchungen.Name := 'mnZeitbuchungen';
    mnZeitbuchungen.Caption := 'Zeitbuchungen';
    SetEvent(mnZeitbuchungen, Self, 'OnClick', 'mnZeitbuchungenClick');
    mnSystem.SetParentComponent(mMainmenu);
    mnSystem.Name := 'mnSystem';
    mnSystem.Caption := 'System';
    mnSystem.Enabled := False;
    mnSystem.Visible := False;
    mnAktivesFahrzeug.SetParentComponent(mnSystem);
    mnAktivesFahrzeug.Name := 'mnAktivesFahrzeug';
    mnAktivesFahrzeug.Caption := 'Aktives Fahrzeug';
    SetEvent(mnAktivesFahrzeug, Self, 'OnClick', 'mnAktivesFahrzeugClick');
    mnFormSchliessen.SetParentComponent(mnSystem);
    mnFormSchliessen.Name := 'mnFormSchliessen';
    mnFormSchliessen.Caption := 'Formular schlie'#223'en';
    SetEvent(mnFormSchliessen, Self, 'OnClick', 'mnFormSchliessenClick');
    Passwortndern1.SetParentComponent(mnSystem);
    Passwortndern1.Name := 'Passwortndern1';
    Passwortndern1.Caption := 'Passwort '#228'ndern';
    Passwortndern1.Enabled := False;
    mnInfo.SetParentComponent(mnSystem);
    mnInfo.Name := 'mnInfo';
    mnInfo.Caption := 'Info';
    SetEvent(mnInfo, Self, 'OnClick', 'mnInfoClick');
    mnAbmelden.SetParentComponent(mMainmenu);
    mnAbmelden.Name := 'mnAbmelden';
    mnAbmelden.Caption := 'Abmelden';
    mnAbmelden.Enabled := False;
    SetEvent(mnAbmelden, Self, 'OnClick', 'mnAbmeldenClick');
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := XDataConn;
    XDataWebClient.Left := 580;
    XDataWebClient.Top := 120;
    tabAnwAbw.SetParentComponent(Self);
    tabAnwAbw.Name := 'tabAnwAbw';
    tabAnwAbw.EntitySetName := 'ANWABW';
    tabAnwAbw.Connection := XDataConn;
    tabAnwAbw.Left := 608;
    tabAnwAbw.Top := 176;
    tabAnwAbwANWABW_NR.SetParentComponent(tabAnwAbw);
    tabAnwAbwANWABW_NR.Name := 'tabAnwAbwANWABW_NR';
    tabAnwAbwANWABW_NR.FieldName := 'ANWABW_NR';
    tabAnwAbwANWABW_BEZ.SetParentComponent(tabAnwAbw);
    tabAnwAbwANWABW_BEZ.Name := 'tabAnwAbwANWABW_BEZ';
    tabAnwAbwANWABW_BEZ.FieldName := 'ANWABW_BEZ';
    tabAnwAbwANWABW_TYP.SetParentComponent(tabAnwAbw);
    tabAnwAbwANWABW_TYP.Name := 'tabAnwAbwANWABW_TYP';
    tabAnwAbwANWABW_TYP.FieldName := 'ANWABW_TYP';
    tabAnwAbwANWABW_KURZ.SetParentComponent(tabAnwAbw);
    tabAnwAbwANWABW_KURZ.Name := 'tabAnwAbwANWABW_KURZ';
    tabAnwAbwANWABW_KURZ.FieldName := 'ANWABW_KURZ';
    tabAnwAbwANWABW_KURZ.Size := 5;
    tabAnwAbwANWABW_FARBE.SetParentComponent(tabAnwAbw);
    tabAnwAbwANWABW_FARBE.Name := 'tabAnwAbwANWABW_FARBE';
    tabAnwAbwANWABW_FARBE.FieldName := 'ANWABW_FARBE';
    tabAnwAbwANWABW_FARBE.Size := 30;
  finally
    pnlMenu.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    lbWebTitel.AfterLoadDFMValues;
    lbBenutzer.AfterLoadDFMValues;
    WebSplitter1.AfterLoadDFMValues;
    MainScrollBox.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    XDataConn.AfterLoadDFMValues;
    tmrJWTRenewal.AfterLoadDFMValues;
    tmrJWTRenewalWarning.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    tmrCapture.AfterLoadDFMValues;
    mMainmenu.AfterLoadDFMValues;
    mnDispo.AfterLoadDFMValues;
    mnTransportauftraege.AfterLoadDFMValues;
    ouren1.AfterLoadDFMValues;
    mnResponsiv.AfterLoadDFMValues;
    mnFahrzeuge.AfterLoadDFMValues;
    mnAbfKontrolle.AfterLoadDFMValues;
    mnSchaeden.AfterLoadDFMValues;
    Position1.AfterLoadDFMValues;
    mnMitarbeiter.AfterLoadDFMValues;
    mnFsKontrollen.AfterLoadDFMValues;
    mnMaterialBestellungen.AfterLoadDFMValues;
    MitarbeiterBelege1.AfterLoadDFMValues;
    mnUrlaub.AfterLoadDFMValues;
    mnZeitbuchungen.AfterLoadDFMValues;
    mnSystem.AfterLoadDFMValues;
    mnAktivesFahrzeug.AfterLoadDFMValues;
    mnFormSchliessen.AfterLoadDFMValues;
    Passwortndern1.AfterLoadDFMValues;
    mnInfo.AfterLoadDFMValues;
    mnAbmelden.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
    tabAnwAbw.AfterLoadDFMValues;
    tabAnwAbwANWABW_NR.AfterLoadDFMValues;
    tabAnwAbwANWABW_BEZ.AfterLoadDFMValues;
    tabAnwAbwANWABW_TYP.AfterLoadDFMValues;
    tabAnwAbwANWABW_KURZ.AfterLoadDFMValues;
    tabAnwAbwANWABW_FARBE.AfterLoadDFMValues;
  end;
end;

end.

